// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { GrowthProfileModal_EntityFragment } from '../../GrowthProfileModal/graphql/GrowthProfileModal.generated';
import { gql } from '@apollo/client';
import { GrowthProfileModal_EntityFragmentDoc } from '../../GrowthProfileModal/graphql/GrowthProfileModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomEntityGrowthModal_EntityFragment = (
  { __typename?: 'Entity', id: string, subtype: { __typename: 'CCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CLTTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CRTTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CustodialPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'DonorAdvisedFund', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename: 'GPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'GRATTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'ILITTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'IndividualPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'InsurancePersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'IrrevocableTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'JointPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename: 'LLCBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename: 'LPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'PrivateFoundation', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'QPRTTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'QualifiedTuitionPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'RetirementPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'RevocableTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename: 'SCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SLATTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, currentValue: CurrencyUSD } | { __typename: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } }
  & GrowthProfileModal_EntityFragment
);

export type CustomEntityGrowthModal_ProposalFragment = { __typename?: 'Proposal', id: string, displayName: string, cltProposal?: { __typename?: 'CLTProposal', id: string } | null, crtProposal?: { __typename?: 'CRTProposal', id: string } | null };

export type CustomEntityGrowthModalQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type CustomEntityGrowthModalQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & CustomEntityGrowthModal_EntityFragment
      ) | null } | null> | null }, proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: (
        { __typename?: 'Proposal' }
        & CustomEntityGrowthModal_ProposalFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    CustomEntityGrowthModal: 'CustomEntityGrowthModal' as const
  },
  Fragment: {
    CustomEntityGrowthModal_Entity: 'CustomEntityGrowthModal_Entity' as const,
    CustomEntityGrowthModal_Proposal: 'CustomEntityGrowthModal_Proposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CustomEntityGrowthModal_EntityFragmentDoc = gql`
    fragment CustomEntityGrowthModal_Entity on Entity {
  ...GrowthProfileModal_Entity
  id
  subtype {
    id
    displayName
    currentValue
    ... on BusinessEntity {
      __typename
    }
    ... on CLTTrust {
      inEstateStatus
    }
    ... on CRTTrust {
      inEstateStatus
    }
    ... on CustodialPersonalAccount {
      inEstateStatus
    }
    ... on DonorAdvisedFund {
      inEstateStatus
    }
    ... on GRATTrust {
      inEstateStatus
    }
    ... on ILITTrust {
      inEstateStatus
    }
    ... on IndividualPersonalAccount {
      inEstateStatus
    }
    ... on InsurancePersonalAccount {
      inEstateStatus
    }
    ... on IrrevocableTrust {
      inEstateStatus
    }
    ... on JointPersonalAccount {
      inEstateStatus
    }
    ... on PrivateFoundation {
      inEstateStatus
    }
    ... on QPRTTrust {
      inEstateStatus
    }
    ... on QualifiedTuitionPersonalAccount {
      inEstateStatus
    }
    ... on RetirementPersonalAccount {
      inEstateStatus
    }
    ... on RevocableTrust {
      inEstateStatus
    }
    ... on SLATTrust {
      inEstateStatus
    }
  }
}
    ${GrowthProfileModal_EntityFragmentDoc}`;
export const CustomEntityGrowthModal_ProposalFragmentDoc = gql`
    fragment CustomEntityGrowthModal_Proposal on Proposal {
  id
  displayName
  cltProposal {
    id
  }
  crtProposal {
    id
  }
}
    `;
export const CustomEntityGrowthModalDocument = gql`
    query CustomEntityGrowthModal($householdId: ID!) {
  entities(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        ...CustomEntityGrowthModal_Entity
      }
    }
  }
  proposals(where: {hasHouseholdWith: [{id: $householdId}]}) {
    edges {
      node {
        ...CustomEntityGrowthModal_Proposal
      }
    }
  }
}
    ${CustomEntityGrowthModal_EntityFragmentDoc}
${CustomEntityGrowthModal_ProposalFragmentDoc}`;

/**
 * __useCustomEntityGrowthModalQuery__
 *
 * To run a query within a React component, call `useCustomEntityGrowthModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomEntityGrowthModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomEntityGrowthModalQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useCustomEntityGrowthModalQuery(baseOptions: Apollo.QueryHookOptions<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>(CustomEntityGrowthModalDocument, withFetchPolicyContext(options));
      }
export function useCustomEntityGrowthModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>(CustomEntityGrowthModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCustomEntityGrowthModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>(CustomEntityGrowthModalDocument, withFetchPolicyContext(options));
        }
export type CustomEntityGrowthModalQueryHookResult = ReturnType<typeof useCustomEntityGrowthModalQuery>;
export type CustomEntityGrowthModalLazyQueryHookResult = ReturnType<typeof useCustomEntityGrowthModalLazyQuery>;
export type CustomEntityGrowthModalSuspenseQueryHookResult = ReturnType<typeof useCustomEntityGrowthModalSuspenseQuery>;
export type CustomEntityGrowthModalQueryResult = Apollo.QueryResult<CustomEntityGrowthModalQuery, CustomEntityGrowthModalQueryVariables>;